import styled, { css } from 'styled-components';

import { rem } from '@vimeo/bokeh';
import { core } from '@vimeo/iris/tokens';

import { TOOLBAR_COLLAPSED_SIZE, TOOLBAR_EXPANDED_SIZE } from '../utils/constants';

interface IContainerProps {
  isPortrait?: boolean;
  isKeyboardOpened?: boolean;
  marginLeft?: string;
  toolbarAttachPosition: 'bottom' | 'right';
}

const commonStyleForDesktopView = css`
  flex-shrink: 0;
  overflow: hidden;
  position: relative;
  z-index: 5;
`;

export const InteractionToolsContainerDesktop = styled.div<IContainerProps>`
  ${({ toolbarAttachPosition }) =>
    toolbarAttachPosition === 'right'
      ? css`
          border-left: ${rem(1)} solid ${core.color.stroke};
          ${commonStyleForDesktopView}
          height: 100vh;
          max-width: ${rem(TOOLBAR_EXPANDED_SIZE + 100)};
          margin-left: auto;
        `
      : css`
          ${commonStyleForDesktopView}
          width: 100%;
        `};
`;

const commonStyleForMobileView = css`
  z-index: 5;
`;

export const InteractionToolsContainerMobile = styled.div<IContainerProps>`
  ${({ toolbarAttachPosition, isKeyboardOpened }) =>
    toolbarAttachPosition === 'bottom'
      ? css`
          ${commonStyleForMobileView}
          position: relative;
          bottom: ${isKeyboardOpened ? rem(-TOOLBAR_COLLAPSED_SIZE) : 0};
          border-top: ${rem(1)} solid ${core.color.stroke};
          width: 100%;
        `
      : css`
          ${commonStyleForMobileView}
          height: 100%;
          position: relative;
          right: 0;
          top: 0;
        `};
`;
